import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style

/* 路由配置 */
router.beforeEach(async(to, from, next) => {
    const t = to.query && to.query.t
    if (t) {
        const {data: {code, content}} = await Vue.prototype.$http('POST', '/principal/info', {
            data: {
                token: t
            }
        })
        code === 200 && (sessionStorage.setItem('userInfo', JSON.stringify(content)))
        sessionStorage.setItem('token', t)
    }
    const token = sessionStorage.getItem('token')
    NProgress.start()
    // 如果要跳转到登录页,清空session数据，并清除vuex缓存
    if (to.path === '/login') {
        sessionStorage.removeItem('token')
        store.commit('DEL_ALL_NAVTAGS')
    }
    // 没有token就跳转到登录
    if (!token && to.path !== '/login') {
        next({ path: '/login' })
        NProgress.done()
        return
    }
    // 有token但是没有授权则添加授权菜单
    if (token && !store.state.authorized) {
        store.dispatch('setMenuList', token === 'whosyourdaddy').then(res => {
            router.addRoutes(store.state.menuList)
            next({ ...to, replace: true }) // hack方法，等待routes加载完毕
        })
    } else {
        next()
    }
})

router.afterEach((to, from) => {
    NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js